import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './store'

import 'script!what-input'
import 'script!foundation-sites'
import './scss/app.scss'

import App from './App.vue'
import VueBreadcrumbs from './lib/plugins/breadcrumbs'
import VueAttributes from './lib/plugins/attributes'
import VueFoundation from './lib/plugins/foundation'
import MomentDates from './lib/plugins/dates'
import StringHelper from './lib/plugins/stringHelper'
import CurrencyHelper from './lib/plugins/currency'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VMdDateRangePicker from 'v-md-date-range-picker'
import Routes from './routes/main.js'
import acl from './lib/plugins/acl'


Vue.use(acl, {
  handler: (value, arg = 'can', modifiers) => {
    // console.log('handler here', value, arg, modifiers)
    const user = store.state.userStore

    if (value === '*' || user.isRoot) {
      return true
    }

    var prms = store.state.userStore.user.roles.flatMap((item) => {
      return item.permissions
    }).map((item) => item.name)

    var has = prms.includes(value)
    //console.log(value, has)
    return has
  }
})
Vue.component('app', App)

Vue.use(VueRouter)
Vue.use(VueResource)

Vue.use(VueBreadcrumbs)
Vue.use(VueAttributes)
Vue.use(VueFoundation)
Vue.use(MomentDates)
Vue.use(StringHelper)
Vue.use(CurrencyHelper)
Vue.use(CKEditor)
Vue.use(VMdDateRangePicker)

const router = new VueRouter({
  mode: 'history',
  routes: Routes
})


router.beforeResolve((to, from, next) => {
  const hasToken = (localStorage.getItem('backoffice-token') != null)
  if (hasToken && store.state.userStore.user === null) {
    store.dispatch('init')
    store.dispatch('profile').then(() => {
      next()
    })
  } else {
    next()
  }
})
// localStorage.removeItem(key);
// localStorage.setItem('testObject', JSON.stringify(testObject));
// var retrievedObject = localStorage.getItem('backoffice-token')

router.beforeEach((to, from, next) => {
  var hasToken = (localStorage.getItem('backoffice-token') != null)

  if (to.name == 'login') {
    next()
  } else {
    if (hasToken) {
      if (to.path.includes('login')) {
        next({
          path: to.path.replace('login', '')
        })
      } else {
        next()
      }
    } else {
      next({
        name: 'login'
      })
    }
  }

})


router.afterEach((to, from) => {
  Vue.nextTick(() => {
      const ucWords = (string) => string !== undefined ? string.charAt(0).toUpperCase() + string.substring(1).toLowerCase() : ''


      let title = to.name.replace(/^(\w+)?(-)?(\w+)?/, (match, p1, p2, p3) => `${ucWords(p1)} ${ucWords(p3)}`)
      if (to.hasOwnProperty('params') && to.params.hasOwnProperty('id') && to.params.id !== null) {
        title += ` #${to.params.id}`
      }
      document.title = `${title} - PLAYMOOVE`;
    }
  )

})

const app = new Vue({
  router,
  store
}).$mount('#app')

//MaggieHelper.notification("Application loaded :)", "have a nice day")

//MaggieHelper.checkForToken()



// WEBPACK FOOTER //
// ./src/main.js